export default {
  'setting.name': 'Cài đặt',
  'roles.title': 'Quản lý vai trò',
  'roles.name': 'Tên vai trò',
  'roles.rolePermissions': 'Quyền',
  'roles.permissionCodes': 'Quyền',
  'roles.createdAt': 'Ngày tạo',
  'roles.action': 'Thao tác',
  'Per.Users.Create': 'Thêm user',
  'Per.Users.Delete': 'Xoá user',
  'Per.Users.Edit': 'Sửa user',
  'Per.Users.Export': 'Xuất user',
  'Per.Users.View': 'Xem user',
  'roles.create': 'Tạo vai trò',
  'roles.information': 'Thông tin vai trò',
  'roles.update': 'Chỉnh sửa vai trò',
  'Mes.Users.Role.UpdateSuccessfully': 'Cập nhật vai trò thành công',
  'Mes.Roles.Add.Successfully': 'Thêm vai trò thành công',

  'roles.createdBy': 'Tạo bởi',
  'roles.createDateTime': 'Ngày tạo',
  'roles.internalComment': 'Ghi chú',
  'roles.isActive': 'Trạng thái hoạt động',
  'roles.delete': 'Xoá vai trò',
  'roles.content.delete': 'Bạn có chắc chắn muốn xóa vai trò này không?',
  'roles.add.name': 'Thêm mới vai trò',
  'roles.info.name': 'Thông tin vai trò',
  'roles.edit.name': 'Cập nhật vai trò',

  'roles.code': 'Mã vai trò',
  'roles.numberOfAssign': 'Số tài khoản được phân quyền',

  'roles.delete.title': 'Xoá vai trò',
  'roles.delete.content': 'Bạn có chắc chắn muốn xóa vai trò này không?',

  Users: 'Người dùng',
  Roles: 'Vai trò',
  Areas: 'Khu vực',
  Gifts: 'Quà tặng',
  Locations: 'Địa điểm',
  RecyclingMachines: 'Máy tái chế',
  Robots: 'Robot',
  UsersView: 'Xem người dùng',
  UsersViewDetail: 'Xem chi tiết người dùng',
  UsersCreate: 'Tạo người dùng',
  UsersUpdate: 'Cập nhật người dùng',
  UsersDelete: 'Xóa người dùng',
  AreasView: 'Xem khu vực',
  AreasViewDetail: 'Xem chi tiết khu vực',
  AreasCreate: 'Tạo khu vực',
  AreasUpdate: 'Cập nhật khu vực',
  AreasDelete: 'Xóa khu vực',
  LocationsView: 'Xem vị trí',
  LocationsViewDetail: 'Xem chi tiết vị trí',
  LocationsCreate: 'Tạo vị trí',
  LocationsUpdate: 'Cập nhật vị trí',
  LocationsDelete: 'Xóa vị trí',
  GiftsView: 'Xem danh sách quà tặng',
  GiftsViewDetail: 'Xem chi tiết quà tặng',
  GiftsCreate: 'Tạo quà tặng',
  GiftsUpdate: 'Cập nhật quà tặng',
  GiftsDelete: 'Xóa quà tặng',
  RecyclingMachinesView: 'Xem danh sách máy tái chế',
  RecyclingMachinesViewDetail: 'Xem chi tiết máy tái chế',
  RecyclingMachinesCreate: 'Tạo máy tái chế',
  RecyclingMachinesUpdate: 'Cập nhật máy tái chế',
  RecyclingMachinesDelete: 'Xóa máy tái chế',
  RobotsView: 'Xem danh sách robot',
  RobotsViewDetail: 'Xem chi tiết robot',
  RobotsCreate: 'Tạo robot',
  RobotsUpdate: 'Cập nhật robot',
  RobotsDelete: 'Xóa robot',
  RolesView: 'Xem vai trò',
  RolesViewDetail: 'Xem chi tiết vai trò',
  RolesCreate: 'Tao vai trò',
  RolesUpdate: 'Cập nhật vai trò',
  RolesDelete: 'Xóa vai trò',
};
